import React, { useMemo } from "react";
import styled, { css } from "styled-components";

import { Text } from "src/library/components/Text";
import { IProductNutritionValue } from "src/core/products/api/products.api";
import ProductNutritionValuesTableHeaders from "src/core/products/components/ProductNutritionValuesTable/ProductNutritionValuesTableHeaders";
import ProductNutritionValuesTableRow from "src/core/products/components/ProductNutritionValuesTable/ProductNutritionValuesTableRow";
import { transformNutritionData } from "src/core/products/components/ProductNutritionValuesTable/helpers";

interface ProductNutritionValuesTableProps {
  nutritionValues: IProductNutritionValue[]
}

/**
 * Takes array of nutrition values, and renders a table displaying values
 */
const ProductNutritionValuesTable: React.ReactFCWithChildren<ProductNutritionValuesTableProps> = ({ nutritionValues }) => {
  const { energy, nutritionData } = useMemo(() => {
    return transformNutritionData(nutritionValues);
  }, [ nutritionValues ]);

  if (nutritionData.length === 0) {
    return null;
  }

  return (
    <TableWrapper>
      <div className="title">
        <Text
          weight="light"
          color="white"
        >
          Nutritional
        </Text>
      </div>

      <table className="table">
        <tbody>
          <ProductNutritionValuesTableHeaders
            headers={[
              "Typical Values",
              "Per 100g",
              "Per Pack"
            ]}
          />

          <ProductNutritionValuesTableRow
            category="Energy"
            per100={energy?.per100 || ""}
            perItem={energy?.perItem || ""}
          />

          {nutritionData.map(nutritionValue => (
            <ProductNutritionValuesTableRow
              key={nutritionValue.category}
              category={nutritionValue.category}
              per100={nutritionValue.per100}
              perItem={nutritionValue.perItem}
              measurement={nutritionValue.measurement}
            />
          ))}
        </tbody>
      </table>
    </TableWrapper>
  );
};

const TableWrapper = styled.div`
  ${({ theme }) => css`
    width: 50%;
    background: white;
    border-right: 1px solid black;
    border-left: 1px solid black;
    
    .title {
      background-color: black;
      padding: ${theme.spacing.padding.xs}
    }
    
    .table {
      width: 100%;
    }
  `}
  
`;

export default ProductNutritionValuesTable;
